"use client";

import { useState } from "react";

export type DathaconsMobileNavItem = { label: string; sectionId: string };

interface MobileMenuProps {
  phone: string;
  email: string;
  nav: DathaconsMobileNavItem[];
  activeSectionId?: string;
  onNavigate: (sectionId: string) => void;
  onContact: () => void;
}

export function MobileMenu({
  phone,
  email,
  nav,
  activeSectionId,
  onNavigate,
  onContact,
}: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (sectionId: string) => {
    onNavigate(sectionId);
    setIsOpen(false);
  };

  const handleContact = () => {
    onContact();
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="mobile-menu-button"
        onClick={() => setIsOpen(true)}
        aria-label="Mở menu"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="mobile-menu-overlay"
            onClick={() => setIsOpen(false)}
            role="presentation"
          />

          <div className="mobile-menu-panel">
            <div className="flex items-center justify-between p-5 border-b border-[#e3e3e3]">
              <span className="font-semibold text-[#303030] text-[16px]">MENU</span>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="w-10 h-10 flex items-center justify-center text-[#303030] hover:text-[#ffa411] transition-colors"
                aria-label="Đóng menu"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div className="flex flex-col py-4">
              {nav.map((item) => {
                const active =
                  activeSectionId === item.sectionId ||
                  (activeSectionId === undefined && item.sectionId === nav[0]?.sectionId);
                return (
                  <button
                    key={item.sectionId}
                    type="button"
                    onClick={() => handleNavigate(item.sectionId)}
                    className={
                      active
                        ? "font-semibold text-[#ffa411] text-[16px] text-left px-6 py-4 hover:bg-[#f5f5f5] transition-colors"
                        : "font-normal text-[#303030] text-[16px] text-left px-6 py-4 hover:bg-[#f5f5f5] hover:text-[#ffa411] transition-colors"
                    }
                  >
                    {item.label}
                  </button>
                );
              })}
            </div>

            <div className="border-t border-[#e3e3e3] p-6">
              <div className="flex flex-col gap-4">
                <div className="flex gap-2 items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
                    <path
                      d="M13.825 6.175C13.825 7.823 12.473 9.175 10.825 9.175C9.177 9.175 7.825 7.823 7.825 6.175C7.825 4.527 9.177 3.175 10.825 3.175C12.473 3.175 13.825 4.527 13.825 6.175Z"
                      fill="#FFA411"
                    />
                  </svg>
                  <span className="font-normal text-[#303030] text-[14px]">{phone}</span>
                </div>
                <div className="flex gap-2 items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
                    <path
                      d="M3 5.5L10 10.5L17 5.5M3 5.5V14.5C3 15.052 3.448 15.5 4 15.5H16C16.552 15.5 17 15.052 17 14.5V5.5M3 5.5C3 4.948 3.448 4.5 4 4.5H16C16.552 4.5 17 4.948 17 5.5"
                      stroke="#FFA411"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span className="font-normal text-[#303030] text-[14px]">{email}</span>
                </div>
              </div>

              <button
                type="button"
                onClick={handleContact}
                className="mt-6 w-full bg-[#ffa411] text-white font-semibold text-[15px] px-6 py-3 rounded-[4px] hover:bg-[#ff9000] transition-colors"
              >
                LIÊN HỆ NGAY
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
